module.exports = __webpack_public_path__ + "static/community-38d13eb0c2d6d195deb3be39065668f8.svg";